import React, { useEffect, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { all_routes } from "../../../../router/all_routes";
import TeacherCard from "./TeacherCard";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../../UserPermissionsContext";
import AddSedTicket from "./AddSedTicket";
import SedTicketLogs from "./SedTicketLogs";
import SedCallLogs from "./SedCallLogs";
import EditSedTicket from "./EditSedTicket";
import CallPopup, { useSEDCallContext } from "./TecacherContext";

export interface TeacherData {
  teacher_id: number;
  building_category: string;
  branch: string;
  full_name: string;
  designation: string;
  no_of_students: number;
  no_of_sed_paid_students: number;
  has_ticket: boolean;
}

const SEDTeacherTicket = () => {
  const { startCall } = useSEDCallContext();
  const routes = all_routes;
  const location = useLocation();
  // const { r1 } = location.state  || {};
  const navigate = useNavigate();
  const jwtToken = Cookies.get("authToken");

  const { userPermissions, webApi } = useUserPermissions();
  const [searchParams] = useSearchParams();
  const id = Number(searchParams.get("id"));
  const r1 = Number(searchParams.get("r1"));
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [hasTicket, setHasTicket] = useState();
  const [cardData, setCardData] = useState<TeacherData[]>([]);
  const [teacherNumber, setTeacherNumber] = useState("");
  const [activeTab, setActiveTab] = useState("ticket");
  const [showCallModal, setShowCallModal] = useState(false);
  const [selectedTeacherId, setSelectedTeacherId] = useState<number | null>(
    null,
  );
  const [selectedTeacherName, setSelectedTeacherName] = useState("");
  const [showNumberModal, setShowNumberModal] = useState(false);
  const [newPhoneNumber, setNewPhoneNumber] = useState("");
  const [updateLoading, setUpdateLoading] = useState(false);

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject,
    );
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const renderComponent = () => {
    switch (activeTab) {
      case "add":
        return hasTicket ? (
          <EditSedTicket
            teacherId={id}
            onSuccess={() => setActiveTab("ticket")}
          />
        ) : (
          <AddSedTicket
            teacherId={id}
            onSuccess={() => setActiveTab("ticket")}
          />
        );
      case "ticket":
        return <SedTicketLogs teacherId={id} />;
      case "call":
        return <SedCallLogs teacherId={id} />;
      default:
        return null;
    }
  };

  useEffect(() => {
    if (!checkPermission("change_sedteacherticket", "sedteacherticket")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchteachersCard();
      fetchteachersNumber();
      fetchteachersAdditionalNumber();  
    }
  }, [userPermissions]);

  // Teachers Cards Data
  const fetchteachersCard = async () => {
    try {
      setIsLoading(true);
      const res = await fetch(
        `${webApi}sed/adaption_teachers_card/${id}/`,
        options,
      );
      const data = await res.json();
      setCardData(data);
      setHasTicket(data.has_ticket);
      setSelectedTeacherName(data.full_name);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  //  fetch Techers Number
  const fetchteachersNumber = async () => {
    try {
      setIsLoading(true);
      const res = await fetch(
        `${webApi}sed/get_sed_teacher_phone_number/?teacher_id=${id}`,
        options,
      );
      const data = await res.json();
      setTeacherNumber(data);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };
  //  fetch Techers AdditionalNumber
  const fetchteachersAdditionalNumber = async () => {
    try {
      setIsLoading(true);
      const res = await fetch(
        `${webApi}sed/update_sed_teacher_phone_number/?teacher_id=${id}`,
        options,
      );
      const data = await res.json();
      setNewPhoneNumber(data.phone_number || "");
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdatePhoneNumber = async () => {
    try {
      setUpdateLoading(true);
      const payload = {
        teacher_id: id,
        phone_number: newPhoneNumber,
      };
      const res = await fetch(
        `${webApi}sed/update_sed_teacher_phone_number/?teacher_id=${id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify(payload),
        },
      );
      const data = await res.json();
      setTeacherNumber(newPhoneNumber);
      setShowNumberModal(false);
    } catch (error) {
      console.error(error);
    } finally {
      setUpdateLoading(false);
    }
  };

  const handleCallClick = (id: number) => {
    setSelectedTeacherId(id);
    setShowCallModal(true);
  };
  const handleConfirmCall = () => {
    if (selectedTeacherId) {
      startCall(selectedTeacherId, selectedTeacherName);
    }
    setShowCallModal(false);
  };

  const handleCancelCall = () => {
    setShowCallModal(false);
  };

  const handleOpenNumberModal = () => {
    // setNewPhoneNumber(teacherNumber);
    setShowNumberModal(true);
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">
                  {" "}
                  {hasTicket ? "Update SED Ticket" : "Add SED Ticket"}
                </h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.SEDDashBoard}>Dashboard</Link>
                  </li>
                  {r1 === 1 ? (
                    <li className="breadcrumb-item">
                      <Link to={routes.SEDTeachers}> Teachers </Link>
                    </li>
                  ) : r1 === 2 ? (
                    <li className="breadcrumb-item">
                      <Link to={routes.SEDDailedTeachers}> Dailed Teachers</Link>
                    </li>
                  ) : r1 === 3 ? (
                    <li className="breadcrumb-item">
                      <Link to={routes.SEDTeachers}> Follow up</Link>
                    </li>
                  ) : null}
                  <li className="breadcrumb-item active">Teacher Ticket</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="container-fluid mt-3">
            <div className="row g-3">
              {/* Teacher Card */}
              <div className="col-12 col-md-6 col-lg-3">
                {/* Teacher Data Card */}
                <TeacherCard
                  teacherData={cardData}
                  phoneNumber={teacherNumber}
                  additionalNumber={newPhoneNumber}
                />
                <button
                  className="btn btn-outline-primary"
                  onClick={handleOpenNumberModal}
                >
                  Update Number
                </button>
              </div>

              {/* Tickets Functionality */}
              <div className="col-12 col-md-6 col-lg-9">
                <div className="card shadow-sm border-0">
                  <div className="card-header bg-white d-flex justify-content-between align-items-center">
                    <div className="d-flex gap-2">
                      <button
                        className={`btn ${
                          activeTab === "add" ? "btn-primary" : "btn-light"
                        }`}
                        onClick={() => setActiveTab("add")}
                      >
                        {hasTicket ? "Update Ticket" : "Add Ticket"}
                      </button>

                      <button
                        className={`btn ${
                          activeTab === "ticket" ? "btn-primary" : "btn-light"
                        }`}
                        onClick={() => setActiveTab("ticket")}
                      >
                        Ticket Logs
                      </button>

                      <button
                        className={`btn ${
                          activeTab === "call" ? "btn-primary" : "btn-light"
                        }`}
                        onClick={() => setActiveTab("call")}
                      >
                        Call Logs
                      </button>
                    </div>

                    {/* <button className="btn btn-success px-4">Call</button> */}
                    <button
                      className="btn btn-success px-4"
                      onClick={() => handleCallClick(id)}
                    >
                      Call
                    </button>
                  </div>

                  {/* Body */}
                  <div className="card-body" style={{ minHeight: "350px" }}>
                    {renderComponent()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showCallModal && (
          <div
            className="modal d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content border-0 shadow-lg rounded-4">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Call</h5>
                </div>

                <div className="modal-body text-center py-4">
                  <h6>
                    Do you want to call <b>{selectedTeacherName}</b>?
                  </h6>
                </div>

                <div className="modal-footer justify-content-center">
                  <button
                    className="btn btn-secondary px-4 m-2"
                    onClick={handleCancelCall}
                  >
                    No
                  </button>

                  <button
                    className="btn btn-success px-4 m-2"
                    onClick={handleConfirmCall}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {showNumberModal && (
          <div
            className="modal d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content border-0 shadow-lg rounded-4">
                <div className="modal-header">
                  <h5 className="modal-title">Update Teacher Number</h5>
                </div>

                <div className="modal-body">
                  <label className="form-label">Phone Number</label>

                  <input
                    type="text"
                    className="form-control"
                    maxLength={10}
                    value={newPhoneNumber}
                    onChange={(e) => setNewPhoneNumber(e.target.value)}
                    placeholder="Enter phone number"
                  />
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary m-2"
                    onClick={() => setShowNumberModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-primary m-2"
                    disabled={updateLoading}
                    onClick={handleUpdatePhoneNumber}
                  >
                    {updateLoading ? "Updating..." : "Update"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <CallPopup />
    </div>
  );
};

export default SEDTeacherTicket;
